import {
    PRODUCT_HURTON_CATEGORIES_FETCH_SUCCESS,
    PRODUCT_HURTON_CATEGORIES_FETCHING,
    PRODUCT_HURTON_CATEGORIES_FETCH_FAILURE,
} from '../../actions/types'

/**
 * @prop {object[]} items
 * @prop {boolean} fetching
 */
const INITIAL_STATE = {
    items: [],
    fetching: false,
}

const reducer = (
    state = INITIAL_STATE,
    /** @type {{ type: string; payload: object; }} */ action
) => {
    switch (action.type) {
        case PRODUCT_HURTON_CATEGORIES_FETCH_SUCCESS:
            return {
                ...state,
                items: action.payload.categories,
                fetching: false,
            }

        case PRODUCT_HURTON_CATEGORIES_FETCHING:
            return {
                ...state,
                fetching: true,
            }

        case PRODUCT_HURTON_CATEGORIES_FETCH_FAILURE:
            return {
                ...state,
                fetching: false,
            }

        default:
            return state
    }
}

export default reducer
